// Calcul du montant total client affiché (prix Amadeus + commissions), partagé
// entre Home.js et PassengerForm.js pour garantir une répartition identique.
import airports from "../data/airports.json";

// Commissions par billet
export const NATIONAL_COMMISSION = 20000; // CI → CI
export const INTERNATIONAL_COMMISSION = 50000; // tous les autres trajets

const getCountryByIata = (iataCode) => {
  const airport = airports.find((a) => a.iata_code === iataCode);
  return airport?.iso_country || null;
};

// Pays de départ / arrivée d'un vol (1er segment départ, dernier segment arrivée)
export function getFlightCountries(flight) {
  try {
    const firstItinerary = flight?.itineraries?.[0];
    const segments = firstItinerary?.segments || [];
    if (!segments.length) return { depCountry: null, arrCountry: null };
    const firstSegment = segments[0];
    const lastSegment = segments[segments.length - 1];
    return {
      depCountry: getCountryByIata(firstSegment?.departure?.iataCode),
      arrCountry: getCountryByIata(lastSegment?.arrival?.iataCode),
    };
  } catch (e) {
    return { depCountry: null, arrCountry: null };
  }
}

// Commission selon les pays (CI↔CI unique → national)
export function commissionPerRoute(depCountry, arrCountry) {
  return depCountry === "CI" && arrCountry === "CI"
    ? NATIONAL_COMMISSION
    : INTERNATIONAL_COMMISSION;
}

// Montant total client : prix du vol + commission × nb passagers.
// Réutilisé par Home (liste) et PassengerForm (formulaire) → même total et
// donc la même répartition.
export function computeAdjustedPrice(flight, totalPassengers = 1) {
  let basePrice = parseFloat(flight?.price?.total ?? flight?.price ?? 0);
  if (Number.isNaN(basePrice)) basePrice = 0;

  const { depCountry, arrCountry } = getFlightCountries(flight);
  if (!depCountry || !arrCountry) return Math.round(basePrice);

  const commission = commissionPerRoute(depCountry, arrCountry);
  return Math.round(basePrice + commission * (totalPassengers || 1));
}